import React, { ReactNode, createContext, useContext, useState } from "react";

type PlayerControlsContextType = {
  tempTime: number;
  setTempTime: (time: number) => void;
  seek: (videoRef: React.RefObject<HTMLVideoElement>, time: number) => void;
  showControls: boolean;
  setShowControls: React.Dispatch<React.SetStateAction<boolean>>;
  controlsLock: boolean;
  setControlsLock: React.Dispatch<React.SetStateAction<boolean>>;
};

const PlayerControlsContext = createContext<PlayerControlsContextType | undefined>(undefined);

export const PlayerControlsProvider = ({ children }: { children: ReactNode }) => {
  const [tempTime, setTempTime] = useState<number>(0);
  const [showControls, setShowControls] = useState<boolean>(true);
  const [controlsLock, setControlsLock] = useState<boolean>(true);

  const seek = (videoRef: React.RefObject<HTMLVideoElement>, time: number) => {
    const video = videoRef.current;
    if (!video) return;
    const newTime = Math.min(Math.max(video.currentTime + time, 0), video.duration);
    video.currentTime = newTime;
    setTempTime(newTime);
  };

  return (
    <PlayerControlsContext.Provider
      value={{ tempTime, setTempTime, seek, showControls, setShowControls, controlsLock, setControlsLock }}
    >
      {children}
    </PlayerControlsContext.Provider>
  );
};

export const usePlayerControls2 = (): PlayerControlsContextType => {
  const context = useContext(PlayerControlsContext);
  if (!context) {
    throw new Error("usePlayerControls must be used within a PlayerControlsProvider");
  }
  return context;
};
